// Every ds2 overlay panel (Drawer, Modal, AlertDialog, DatePicker, Popover) carries `data-ds2-overlay`. They portal to
// <body> in mount order, or (an un-portaled Popover) sit inside the overlay that opened them, so the last marked element in
// the document is the one the user is looking at.
//
// Each overlay listens for Escape on `document`. Without this check a Modal opened from a Drawer closes
// both on one keypress, so only the topmost overlay may react to the keyboard.
export const isTopmostOverlay = (el: HTMLElement | null): boolean => {
    if (!el) return false
    const overlays = document.querySelectorAll('[data-ds2-overlay]')
    return overlays[overlays.length - 1] === el
}

// One body scroll lock shared by every ds2 overlay. Each overlay saving and restoring `overflow` on its own breaks
// when two close in the same commit: the one opened second saved `hidden`, its cleanup runs last, and the page
// stays locked. Counting keeps the value from before the first overlay and restores it when the last one closes.
let lockCount = 0
let overflowBeforeLock = ''

export const lockBodyScroll = (): (() => void) => {
    if (lockCount === 0) overflowBeforeLock = document.body.style.overflow
    lockCount += 1
    document.body.style.overflow = 'hidden'
    let released = false
    return () => {
        if (released) return
        released = true
        lockCount = Math.max(0, lockCount - 1)
        if (lockCount === 0) document.body.style.overflow = overflowBeforeLock
    }
}
